import type { InputHTMLAttributes } from 'react';
import { cn } from '@/lib/utils/cn';

/** Basisklassen, die ein übergebenes `className` ersetzt (sonst entscheidet die Reihenfolge im Stylesheet). */
const BASIS: [prefix: RegExp, klasse: string][] = [[/(^|\s)h-/, 'h-9'], [/(^|\s)w-/, 'w-full'], [/(^|\s)px-/, 'px-3'], [/(^|\s)text-\[?\d|(^|\s)text-(xs|sm|base)/, 'text-sm']];

export function Input({ className, ...rest }: InputHTMLAttributes<HTMLInputElement>) {
  const basis = BASIS.filter(([muster]) => !muster.test(className ?? '')).map(([, k]) => k);
  return (
    <input
      className={cn(
        'rounded-md border border-line bg-surface text-ink',
        basis.join(' '),
        'placeholder:text-ink-faint',
        'focus:border-accent focus:outline-none focus-visible:outline-none',
        className,
      )}
      {...rest}
    />
  );
}
